import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { textMapping } from "../utils/helper";

const Congratulation = () => {
  return (
    <>
      <div className="cong_bg">
        <div className="cong_pos">
          <button className="cross_tag">
            <img src="/assets/images/cross.svg" alt="" />
          </button>
          <img src="/assets/images/congrats.svg" alt="" />
          <h2>{textMapping("Congratulations !")}</h2>
          <p>
            Your primary member ID <span>{localStorage.getItem("mem_id")}</span>
          </p>
        </div>
      </div>
    </>
  );
};

export default Congratulation;
